module.exports = __webpack_public_path__ + "img/apetopia.3344b572.png";